import { render, staticRenderFns } from "./ChatNew.vue?vue&type=template&id=4141a09a"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4141a09a')) {
      api.createRecord('4141a09a', component.options)
    } else {
      api.reload('4141a09a', component.options)
    }
    module.hot.accept("./ChatNew.vue?vue&type=template&id=4141a09a", function () {
      api.rerender('4141a09a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/ChatNew.vue"
export default component.exports